import { InternalUser } from '../domain/InternalUser'
import { InternalUserFindResponse } from './find/dto/InternalUserFindResponse'

export const internalUserModelFromResponse = (resUser: InternalUserFindResponse): InternalUser => ({ ...resUser })
